import React from "react";
import mamtaShah from "../assets/images/mamta-shah.jpg";
import mamtaShahdesing from "../assets/images/designer-boutique-bhopal.png";
import designPhilosophy from "../assets/images/design-philosophy.jpg";


const About = () => {
    return (
        <div>
            <section className="p70 breadcru">
                <div className="container">
                    <div className="row">
                        <nav>
                            <ol className="breadcrumb"></ol>
                        </nav>
                    </div>
                </div>
            </section>



            <section class="p70">
                <div class="container-fluid2">
                    <div class="row">
                        <div class="col-md-5 col-sm-5 wow fadeInUp">
                            <img   src={mamtaShah}
                                alt="Mamta-Shah" class="img-fluid img-border" /></div>
                        <div class="col-md-6 col-sm-6 text-justify wow fadeInRight"  >
                            <h2 class="green-text">Woman behind the dream</h2>

                            <p>Mamta Shah, the woman behind the art and craft of styling at Sakhi Designer Studio, is a creative person and visionary persona whose dream materialized into a reality - To cater to every fashion need of women with grace and elegance.</p>

                            <p>Inspired by the vibrant colors of nature, she embarked on a mission to infuse these hues into people's lives through unique yarns and textures. This passion led her to explore new places and uncover exquisite patterns, all while appreciating the intricate beauty of artisan works from various parts of the country. Enchanted by the deep-rooted artistry within these artisans, she pledged to make it a signature style for consumers. Her journey is indeed incredible!</p>
                        </div>
                    </div>
                </div>
            </section>

            <section class="story">
                <div class="container">
                    <div class="row text-center">
                        <aside class="col-md-12">
                            <img src={mamtaShahdesing} alt="designer boutique in bhopal"
                                width="290" height="67" />
                            <h2 class=" white-text"><big>A breath-taking tale of woven craftmanship.</big></h2>
                        </aside>
                    </div>
                </div>
            </section>



            <section class="p70">
                <div class="container">
                    <div class="row">
                        <div class="col-md-7 col-sm-7 text-justify wow fadeInRight">
                            <h2 class="green-text">Design Philosophy</h2>

                            <p>"She is unique and she needs a unique style statement."</p>

                            <p>With an experience of 5 years working with one of the leading clothing brands in the country; Mamta found out what’s missing and made it a point to fill in the gap. She has been successful in greatly influencing women’s fashion outlook in the city with a good understanding of Indian women and their unique individuality and appreciating that every woman has a distinct personality and she expresses it through her original style. </p>

                            <p>SDS customizes and creates bespoke outfits suited to individual styles and creates an outfit that a person can own in the true sense!</p>
                        </div>

                        <div class="col-md-5 col-sm-5 wow fadeInUp " >
                            <img src={designPhilosophy} alt="Design-Philosophy" class="img-fluid img-border" />
                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
};

export default About;